import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
const totalIndex = [];
export const compute = (data) => {

    return _.cloneDeep(data);
}

export const columns = (onChange, date) => {
    return [
        {
            title: <div>酒店名称</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 250,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                return <TableText data={props} />
            }
        },
        {
            title: `出租率`,
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "occ",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
        {
            title: `平均房价（人民币）`,
            dataIndex: 'adr',
            key: 'adr',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "adr",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
        {
            title: `平均每间房收益`,
            dataIndex: 'revpar',
            key: 'revpar',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "revpar",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
        {
            title: `房费合计`,
            dataIndex: 'room',
            key: 'room',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "room",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
        {
            title: `餐饮合计`,
            dataIndex: 'fb',
            key: 'fb',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "fb",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
        {
            title: `其他收入总计`,
            dataIndex: 'other',
            key: 'other',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "other",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
        {
            title: `每日总收入总计`,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "rev",
                    onChange,
                    totalIndex
                };
                return <TableText data={props} />
            }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.5/compute.js